import React, { useContext } from 'react';
import { Image, Title2 } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useLoginErrorPageStyles } from './styles';
import MicrosoftAdvertisingLogo from '../media/microsoft-advertising-logo-idp-header.png';

export type LoginErrorCardProps = {
  title: string;
  children: React.ReactNode;
  actions: React.ReactNode;
  idPrefix: string;
  // Optional decorative illustration shown between the logo and the title (e.g. a success checkmark).
  illustration?: React.ReactNode;
};

export const LoginErrorCard: React.FC<LoginErrorCardProps> = ({
  title,
  children,
  actions,
  idPrefix,
  illustration,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useLoginErrorPageStyles();
  const titleId = `${idPrefix}-title`;
  const descriptionId = `${idPrefix}-description`;

  return (
    <main className={`login-error-page ${classes.centeredPage}`}>
      <section className={`login-error-card ${classes.card}`} aria-labelledby={titleId} aria-describedby={descriptionId}>
        <Image
          className={classes.logo}
          src={MicrosoftAdvertisingLogo}
          alt={i18n.getString(_TL_('Microsoft Advertising'))}
        />
        {illustration ? <div className={classes.illustration}>{illustration}</div> : null}
        <Title2 id={titleId} as="h1" className={classes.title}>{title}</Title2>
        <div id={descriptionId} className={classes.description}>{children}</div>
        <div className={classes.actions}>{actions}</div>
      </section>
    </main>
  );
};
